module.exports = __webpack_public_path__ + "img/DSC_0045.0c0eb577.jpg";